import React from "react";
import {  Modal, Button } from 'react-bootstrap';
 
export default function SecretVideo({
	isOpen, toggle , handleClickOnVideo
}) {

	return (
		<Modal
			show={isOpen}
			centered
			size="sm"
			className="secret-video-next-button-popup text-translate-modal"
		>
				  <Modal.Header className="d-flex">
					<Modal.Title className="text-translation popup_heading m-0">
					  &nbsp;
					</Modal.Title>
			
					<Button variant="link" className="modalClose-Btn p-0" onClick={() => toggle()}>
					  <svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						width="24"
						height="24"
					  >
						<path
						  d="M18 6L6 18M6 6l12 12"
						  stroke="currentColor"
						  strokeWidth="2"
						  strokeLinecap="round"
						  strokeLinejoin="round"
						/>
					  </svg>
					</Button>
				  </Modal.Header>
			<Modal.Body className="text-center">
				<div>
					{/* <img src="" alt="some image" /> */}
				</div>
				<p className="simple-text">To view a question strategy video for this task.</p>
				<button onClick={handleClickOnVideo} className="prev-next-btn">Click Here</button>
			</Modal.Body>
		</Modal>
	);
}